import React, {memo, useEffect} from 'react';
import { Link, useRouteMatch } from 'react-router-dom';

import Reports from './Reports/Reports';
import ReportsCash from './ReportsCash/ReportsCash';
import {useSelector} from "react-redux";
import Loader from "../ExchangeCB/Loader";

const viewReports = {
  cash: 'cash',
  reports: 'reports',
};

const ReportsMain = memo(({setTitlePage}) => {
  const match = useRouteMatch();
  const path = match.url.split('/')[2];

  const cash = path === viewReports.cash;
  const reports = path === viewReports.reports;
  const {accessFeatures, isLoadingConfiguration} = useSelector(({user}) => user);

  useEffect(() => {
    accessFeatures['title.header_section'] && setTitlePage('Касса и отчёты');
  }, [isLoadingConfiguration]);

  return (
    <main className="app-content">

      { isLoadingConfiguration ? (<div className="content-inner">
            <Loader pageRange={1}/>
          </div>) :
        ( <>
            {!accessFeatures['title.header_section'] &&
              <div className="content-header">
                <h1>Касса и отчёты </h1>
              </div>}
            <div className="content-inner">
              <div className="content-inner-data">
                <div className="content-tabs">
                  <Link
                    to="/cash-desk/cash"
                    className={`content-tabtrigger button-white ${cash && 'active'}`}>
                    Касса
                  </Link>
                  <Link
                    to="/cash-desk/reports"
                    className={`content-tabtrigger button-white ${reports && 'active'}`}>
                    Отчёты
                  </Link>
                </div>
                {cash && <ReportsCash />}
                {reports && <Reports />}
              </div>
            </div></>

        )}
    </main>
  );
});

export default ReportsMain;
